import { A11yModule } from "@angular/cdk/a11y";
import { CdkOverlayOrigin } from "@angular/cdk/overlay";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatTableModule } from "@angular/material/table";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { IconDirective, SharedUiModule } from "@dtm-frontend/shared/ui";
import { LanguageCode, SharedI18nModule, getTranslocoInlineLoader } from "@dtm-frontend/shared/ui/i18n";
import { TRANSLOCO_SCOPE } from "@jsverse/transloco";
import { LetModule, PushModule } from "@ngrx/component";
import { NgxsModule } from "@ngxs/store";
import { FaqComponent } from "./components/faq/faq.component";
import { InfoComponent } from "./components/info/info.component";
import { MainPageContainerComponent } from "./components/main-page-container/main-page-container.component";
import { MenuComponent } from "./components/menu/menu.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { PilotOperatorSearchComponent } from "./components/pilot-operator-search/pilot-operator-search.component";
import { PromptComponent } from "./components/prompt/prompt.component";
import { ServicesSectionComponent } from "./components/services-section/services-section.component";
import { CaaSubpageComponent } from "./components/subpages/caa-subpage/caa-subpage.component";
import { DroneTowerSubpageComponent } from "./components/subpages/drone-tower-subpage/drone-tower-subpage.component";
import { DssSubpageComponent } from "./components/subpages/dss-subpage/dss-subpage.component";
import { EIdentificationSubpageComponent } from "./components/subpages/e-identification-subpage/e-identification-subpage.component";
import { ELearningSubpageComponent } from "./components/subpages/e-learning-subpage/e-learning-subpage.component";
import { ERegistrationSubpageComponent } from "./components/subpages/e-registration-subpage/e-registration-subpage.component";
import { ESoraSubpageComponent } from "./components/subpages/e-sora-subpage/e-sora-subpage.component";
import { AboutProjectComponent } from "./components/subpages/kpo/about-project/about-project.component";
import { CompetencyCenterInfoComponent } from "./components/subpages/kpo/competency-center-info/competency-center-info.component";
import { CompetitionComponent } from "./components/subpages/kpo/competition/competition.component";
import { KpoFilesComponent } from "./components/subpages/kpo/files/kpo-files.component";
import { KpoLogosComponent } from "./components/subpages/kpo/kpo-logos/kpo-logos.component";
import { KpoNewsSlideDirective } from "./components/subpages/kpo/news/kpo-news-slide.directive";
import { KpoNewsComponent } from "./components/subpages/kpo/news/kpo-news.component";
import { News1Component } from "./components/subpages/kpo/news/news-1/news-1.component";
import { News10Component } from "./components/subpages/kpo/news/news-10/news-10.component";
import { News11Component } from "./components/subpages/kpo/news/news-11/news-11.component";
import { News14Component } from "./components/subpages/kpo/news/news-14/news-11.component";
import { News2Component } from "./components/subpages/kpo/news/news-2/news-2.component";
import { News3Component } from "./components/subpages/kpo/news/news-3/news-3.component";
import { News6Component } from "./components/subpages/kpo/news/news-6/news-6.component";
import { News8Component } from "./components/subpages/kpo/news/news-8/news-8.component";
import { News9Component } from "./components/subpages/kpo/news/news-9/news-9.component";
import { NewsDialogComponent } from "./components/subpages/kpo/news/news-dialog/news-dialog.component";
import { EntityDirective } from "./components/subpages/kpo/registred-entities/entity.directive";
import { RegisteredEntitiesComponent } from "./components/subpages/kpo/registred-entities/registered-entities.component";
import { ResultsComponent } from "./components/subpages/kpo/results/results.component";
import { ScheduleComponent } from "./components/subpages/kpo/schedule/schedule.component";
import { MissionPlanningSubpageComponent } from "./components/subpages/mission-planning-subpage/mission-planning-subpage.component";
import { RoadmapSubpageComponent } from "./components/subpages/roadmap-subpage/roadmap-subpage.component";
import { SahSubpageComponent } from "./components/subpages/sah-subpage/sah-subpage.component";
import { ThreeAreasSubpageComponent } from "./components/subpages/three-areas-subpage/three-areas-subpage.component";
import { WhereYouCanFlyFaqComponent } from "./components/subpages/where-you-can-fly/faq/where-you-can-fly-faq.component";
import { WhereYouCanFlyBannerComponent } from "./components/subpages/where-you-can-fly/main-page-banner/where-you-can-fly-banner.component";
import { CampaignMediaComponent } from "./components/subpages/where-you-can-fly/media/campaign-media.component";
import { CampaignPatronsComponent } from "./components/subpages/where-you-can-fly/patrons/campaign-patrons.component";
import { WhereYouCanFlyComponent } from "./components/subpages/where-you-can-fly/where-you-can-fly.component";
import { SystemStateComponent } from "./components/system-state/system-state.component";
import { WelcomeSectionComponent } from "./components/welcome-section/welcome-section.component";
import { PilotOperatorSearchApiService } from "./services/pilot-operator-search/pilot-operator-search-api.service";
import { PilotOperatorSearchState } from "./services/pilot-operator-search/pilot-operator-search.state";

@NgModule({
    declarations: [
        MainPageContainerComponent,
        WelcomeSectionComponent,
        ServicesSectionComponent,
        CaaSubpageComponent,
        ERegistrationSubpageComponent,
        ELearningSubpageComponent,
        MissionPlanningSubpageComponent,
        ThreeAreasSubpageComponent,
        ESoraSubpageComponent,
        DssSubpageComponent,
        SahSubpageComponent,
        EIdentificationSubpageComponent,
        DroneTowerSubpageComponent,
        RoadmapSubpageComponent,
        MenuComponent,
        PromptComponent,
        FaqComponent,
        SystemStateComponent,
        PageNotFoundComponent,
        PilotOperatorSearchComponent,
        AboutProjectComponent,
        CompetitionComponent,
        RegisteredEntitiesComponent,
        EntityDirective,
        ScheduleComponent,
        KpoLogosComponent,
        InfoComponent,
        CompetencyCenterInfoComponent,
        KpoNewsComponent,
        KpoNewsSlideDirective,
        NewsDialogComponent,
        KpoFilesComponent,
        News1Component,
        News2Component,
        News3Component,
        News6Component,
        ResultsComponent,
        News8Component,
        News9Component,
        News10Component,
        News11Component,
        News14Component,
        WhereYouCanFlyComponent,
        WhereYouCanFlyFaqComponent,
        CampaignMediaComponent,
        CampaignPatronsComponent,
        WhereYouCanFlyBannerComponent,
    ],
    imports: [
        CommonModule,
        SharedI18nModule,
        IconDirective,
        LetModule,
        RouterLinkActive,
        RouterLink,
        MatSidenavModule,
        SharedUiModule,
        A11yModule,
        PushModule,
        CdkOverlayOrigin,
        NgOptimizedImage,
        MatInputModule,
        ReactiveFormsModule,
        NgxsModule.forFeature([PilotOperatorSearchState]),
        MatDialogModule,
        MatTableModule,
    ],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            multi: true,
            useValue: {
                scope: "dtmMainPageLib",
                loader: getTranslocoInlineLoader((language: LanguageCode) => import(`../assets/i18n/${language}.json`)),
            },
        },
    ],
    exports: [
        WelcomeSectionComponent,
        ServicesSectionComponent,
        CaaSubpageComponent,
        ERegistrationSubpageComponent,
        ELearningSubpageComponent,
        MissionPlanningSubpageComponent,
        ThreeAreasSubpageComponent,
        ESoraSubpageComponent,
        DssSubpageComponent,
        SahSubpageComponent,
        EIdentificationSubpageComponent,
        DroneTowerSubpageComponent,
        MenuComponent,
        PromptComponent,
        FaqComponent,
        PageNotFoundComponent,
        AboutProjectComponent,
        CompetitionComponent,
        RegisteredEntitiesComponent,
        EntityDirective,
        ScheduleComponent,
        KpoLogosComponent,
        InfoComponent,
        CompetencyCenterInfoComponent,
        KpoNewsComponent,
        KpoNewsSlideDirective,
        NewsDialogComponent,
        KpoFilesComponent,
        ResultsComponent,
        WhereYouCanFlyComponent,
    ],
})
export class MainPageLibModule {
    public static forTest(): ModuleWithProviders<MainPageLibModule> {
        return {
            ngModule: MainPageLibModule,
            providers: [
                {
                    provide: PilotOperatorSearchApiService,
                    useValue: null,
                },
            ],
        };
    }
}
